import {Component, OnInit, ElementRef, Renderer2, ViewChild, AfterViewInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../Services/UserService';
import {first} from 'rxjs/operators';
import swal from "sweetalert2";
import {AuthService} from '../../auth/AuthService';
import {ClientService} from '../../Services/client.service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit,AfterViewInit {
    isSidebarExpanded = false;
    resetPasswordForm!: FormGroup;
    hidePassword = true;
    hideNewPassword = true;
    hideConfirmPassword = true;

    cIdForm!: FormGroup;
    clientList:any = [];
    clientId:any;
    isModalOpen: boolean = false;

    @ViewChild('resetPassword') resetPassModal!: ElementRef;
    @ViewChild('CId') cIdModal!: ElementRef;

    constructor(private el: ElementRef,
                private renderer: Renderer2,
                private fb : FormBuilder,
                private userService: UserService,
                public authService: AuthService,
                private clientServices : ClientService,
                ) {

        this.resetPasswordForm = this.fb.group({
            userName: [null,[Validators.required]],
            currentPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
            newPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
            confirmPassword: [null, [Validators.required, Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$')]],
        }, { validators: this.passwordsMatch });


        this.cIdForm = this.fb.group({
            clientId: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.getClientList()

    }

    ngAfterViewInit(): void {
        // This ensures the ViewChild reference is available after the view has been initialized
        if (this.cIdModal) {
            this.openModali();
            console.error('Modal ViewChild is not available');
        } /*else {
            debugger
            if(this.userType === 'INTERNAL'){
                debugger
                this.openModali();
            }

        }*/
    }

    getClientList() {
        this.clientServices.getClientDetails().pipe(first()).subscribe(
            (response: any) => {
                if (response) {
                    this.clientList = response
                }
            })
    }

    passwordsMatch(form: FormGroup) {
        const newPassword = form.get('newPassword')?.value;
        const confirmPassword = form.get('confirmPassword')?.value;
        return newPassword === confirmPassword ? null : { mismatch: true };
    }

    onSubmit(){
        this.resetPasswordForm.markAllAsTouched()
        if (this.resetPasswordForm.valid) {
            let reqData = {
                userName: this.resetPasswordForm.controls.userName.value,
                currentPassword: this.resetPasswordForm.controls.currentPassword.value,
                newPassword: this.resetPasswordForm.controls.newPassword.value,
            };
            this.userService.resetPassword(reqData).pipe(first()).subscribe(
                (response: any) => {
                    if (response != undefined) {
                        this.closeModal();
                        swal.fire({
                            icon: 'success',
                            text: 'Password updated successfully.',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: response.message,
                            showConfirmButton: false,
                            timer: 5000
                        });
                    }
                },
                (error) => {
                    swal.fire({
                        title: 'Error!',
                        icon: 'error',
                        text: error.error.message,
                        showConfirmButton: false,
                        timer: 5000
                    });
                }
            );
        }
    }

    toggleSidebar(): void {
        this.isSidebarExpanded = !this.isSidebarExpanded; // Toggle the state
        const wrapper = this.el.nativeElement.querySelector('#wrapper');
        if (this.isSidebarExpanded) {
            this.renderer.addClass(wrapper, 'toggled');
            this.closeAllDropdowns();
        } else {
            this.renderer.removeClass(wrapper, 'toggled');
            this.closeAllDropdowns(); // Close all dropdowns when sidebar collapses
        }
    }
    closeAllDropdowns(): void {
        const dropdowns = this.el.nativeElement.querySelectorAll('.collapse.show'); // Find all open dropdowns
        dropdowns.forEach((dropdown: HTMLElement) => {
            this.renderer.removeClass(dropdown, 'show'); // Remove the 'show' class to collapse them
        });
    }
    togglePasswordVisibility(num:any) {
        if(num == 1){
            this.hidePassword = !this.hidePassword;
        }
        if(num == 2){
            this.hideNewPassword = !this.hideNewPassword;
        }
        if(num == 3){
            this.hideConfirmPassword = !this.hideConfirmPassword;
        }
    }
    // method to open the modal and remove background blur
    openModal() {
        this.resetPasswordForm.reset()
        const modalElement = this.resetPassModal.nativeElement;
        modalElement.style.display = 'flex'; // Center modal with flexbox
        modalElement.classList.add('show'); // Add the 'show' class for animation

        // Add blur to the background
        this.renderer.addClass(document.body, 'blur-background');
    }
    // Method to close the modal and remove background blur
    closeModal() {
        this.resetPasswordForm.reset()
        const modalElement = this.resetPassModal.nativeElement;
        modalElement.style.display = 'none'; // Hide modal
        modalElement.classList.remove('show'); // Remove 'show' class

        // Remove blur from the background
        this.renderer.removeClass(document.body, 'blur-background');
    }

    openModali(): void {
        if (this.cIdModal) {  // Ensure ViewChild reference is available
            this.cIdForm.reset();  // Reset form when opening modal
            this.renderer.addClass(document.body, 'blur-background');  // Add background blur effect
            // Optionally, you can access modal directly through nativeElement after ensuring ViewChild is set
            const modalElement = this.cIdModal.nativeElement;
            modalElement.style.display = 'flex';
        } else {
            console.error('Modal element is undefined.');
        }
    }
    closeModali(): void {
        this.cIdForm.reset();  // Reset form when closing modal
        this.renderer.removeClass(document.body, 'blur-background');  // Remove blur effect
        if (this.cIdModal) {
            const modalElement = this.cIdModal.nativeElement;
            modalElement.style.display = 'none';
        }
    }

    onSubmitC(){
        this.cIdForm.markAllAsTouched()
        if (this.cIdForm.value) {
            // this.authService.clientId = this.cIdForm.controls.clientId.value
            if(this.authService.userType === 'INTERNAL'){
                localStorage.setItem('internalClientId', JSON.stringify(this.cIdForm.controls.clientId.value));
            }
            this.closeModali()
        }
    }
}
